export default __webpack_public_path__ + "325c2f2922822eea15ca20fad8b5260e.png";